import styled from "styled-components";

const NavBarContainerStyled = styled.div`
    position: absolute;
    display:flex;
    align-items:center;
    inset:0;
    height:100%;

    &:hover {
        width:212px;
    }
`

export default NavBarContainerStyled;